"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylableOverride = exports.getStateOverrideHints = exports.OverrideHintsErrors = exports.STYLABLE_OVERRIDE_STATE_PREFIX = exports.STATE_SET_VALUE = exports.DEFAULT_OVERRIDE_STATE_PREFIX = void 0;
var stylable_forcestates_plugin_1 = require("@stylable/webpack-extensions/dist/stylable-forcestates-plugin");
exports.DEFAULT_OVERRIDE_STATE_PREFIX = 'data-override-';
exports.STATE_SET_VALUE = 'true';
exports.STYLABLE_OVERRIDE_STATE_PREFIX = stylable_forcestates_plugin_1.OVERRIDE_STATE_PREFIX;
exports.OverrideHintsErrors = {
    MULTIPLE_SELECTORS: 'Multiple selectors are unsupported: ',
    MULTIPLE_PARTS: 'Selectors including multiple parts with states are unsupported: ',
    MULTIPLE_STATES: 'Selectors with multiple states are unsupported: ',
};
var emptyState = { state: '', stateAttribute: '', selectorToQuery: '' };
var getStateOverrideHints = function (selector, overrideStatePrefix // TODO: Deprecate
) {
    var reportError = function (message) {
        throw new Error(message + selector);
    };
    var forceStateMatchers = (0, stylable_forcestates_plugin_1.createForceStateMatchers)(selector);
    if (forceStateMatchers.length === 0) {
        // TODO: check if can return undefined instead
        return emptyState;
    }
    if (forceStateMatchers.length > 1) {
        reportError(exports.OverrideHintsErrors.MULTIPLE_SELECTORS);
    }
    var statesMatcherParts = forceStateMatchers[0];
    var statesMatcherPartsWithStates = statesMatcherParts.filter(function (statesMatcherPart) { return statesMatcherPart.states.length > 0; });
    if (statesMatcherPartsWithStates.length === 0) {
        return emptyState;
    }
    if (statesMatcherPartsWithStates.length > 1) {
        reportError(exports.OverrideHintsErrors.MULTIPLE_PARTS);
    }
    var _a = statesMatcherPartsWithStates[0], states = _a.states, selectorToQuery = _a.selector;
    if (states.length > 1) {
        reportError(exports.OverrideHintsErrors.MULTIPLE_STATES);
    }
    var state = states[0].name;
    return {
        state: state,
        stateAttribute: "".concat(overrideStatePrefix).concat(state),
        selectorToQuery: selectorToQuery,
    };
};
exports.getStateOverrideHints = getStateOverrideHints;
var StylableOverride = /** @class */ (function () {
    function StylableOverride(queryDocument, driver, sheetPath, overrideStatePrefix) {
        if (overrideStatePrefix === void 0) { overrideStatePrefix = exports.DEFAULT_OVERRIDE_STATE_PREFIX; }
        this.queryDocument = queryDocument;
        this.driver = driver;
        this.sheetPath = sheetPath;
        this.overrideStatePrefix = overrideStatePrefix;
        this.selector = '';
        this.prevSelector = '';
        this.sheetDriver = null;
        if (this.driver && this.sheetPath) {
            this.sheetDriver = this.driver.getStylesheet(this.sheetPath);
        }
    }
    StylableOverride.prototype.setSelector = function (selector) {
        this.prevSelector = "".concat(this.selector);
        this.selector = selector || '';
    };
    StylableOverride.prototype.override = function () {
        if (this.prevSelector === this.selector) {
            return;
        }
        this.removeStateOverride();
        this.setStateOverride();
    };
    StylableOverride.prototype.removeStateOverride = function (selector) {
        var overrideSelector = "".concat(selector || this.prevSelector);
        if (!overrideSelector) {
            return;
        }
        var _a = this.getOverrideElements(overrideSelector), elements = _a.elements, stateAttribute = _a.stateAttribute;
        elements && Array.from(elements).forEach(function (element) { return element.removeAttribute(stateAttribute); });
    };
    StylableOverride.prototype.setStateOverride = function (selector) {
        var overrideSelector = "".concat(selector || this.selector);
        if (!overrideSelector) {
            return;
        }
        var _a = this.getOverrideElements(overrideSelector), elements = _a.elements, stateAttribute = _a.stateAttribute;
        elements && Array.from(elements).forEach(function (element) { return element.setAttribute(stateAttribute, exports.STATE_SET_VALUE); });
    };
    StylableOverride.prototype.getOverrideElements = function (selector) {
        var _a = (0, exports.getStateOverrideHints)(selector, this.overrideStatePrefix), selectorToQuery = _a.selectorToQuery, stateAttribute = _a.stateAttribute;
        var targetSelector = selectorToQuery && this.sheetDriver ? this.sheetDriver.getTargetSelector(selectorToQuery) : '';
        return {
            elements: targetSelector ? this.queryDocument && this.queryDocument.querySelectorAll(targetSelector) : [],
            stateAttribute: stateAttribute,
            selectorToQuery: targetSelector,
        };
    };
    return StylableOverride;
}());
exports.StylableOverride = StylableOverride;
//# sourceMappingURL=stylable-override.js.map